import { MessageBox } from "element-ui";
var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
var chnUnitChar = ["", "十", "百", "千"];

import Vue from "@/main";
let utils = {
  //数据过滤
  dictionaryDataFormat(row, st) {
    // 添加安全性检查
    if (st && Array.isArray(st) && row >= 0) {
      for (let i = 0; i < st.length; i++) {
        if (row == st[i].id) {
          return st[i]?.name;
        }
      }
    }
    // 处理未能找到属性的情况，不返回数据
  },
  //删除对象空属性
  removeEmptyValues(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
        delete obj[key];
      } else if (typeof obj[key] === "object") {
        utils.removeEmptyValues(obj[key]);
        if (Object.keys(obj[key]).length === 0) {
          delete obj[key];
        }
      }
    });
    return obj;
  },
  // 过滤空值
  dealObjectValue(obj) {
    var param = {};
    if (obj === null || obj === undefined || obj === "") return param;
    for (var key in obj) {
      if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
        param[key] = obj[key];
      }
    }
    return param;
  },
  getNextUrl(url) {
    let currentList = JSON.parse(sessionStorage.getItem("currentList"));
    let currentId = sessionStorage.getItem("currentId");
    let obj = currentList.find((v) => v.id == currentId);
    if (obj.secondaryMenuDtos) {
      let chi = obj.secondaryMenuDtos.find((v) => v.menuUrl.indexOf(url) > -1);
      if (chi) {
        currentList.push(chi);
        sessionStorage.setItem("currentList", JSON.stringify(currentList));
      }
      return url;
    } else {
      console.error("菜单中未添加该二级菜单！");
    }
  },
  // 时间格式化
  dateFormat(time, fmt) {
    if (!time) return "";
    if (typeof time === "string" && time.includes("T")) {
      time = time.replace("T", " ").replace(/\-/g, "/");
    }

    time = new Date(time);
    var o = {
      "M+": time.getMonth() + 1,
      "d+": time.getDate(),
      "h+": time.getHours(),
      "m+": time.getMinutes(),
      "s+": time.getSeconds(),
      "q+": Math.floor((time.getMonth() + 3) / 3),
      S: time.getMilliseconds(),
    };

    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (time.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    }

    return fmt;
  },
  downloadByRes(data, fileName) {
    const url = URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  },
  // 深拷贝
  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  // 返回数据类型
  dataType(obj) {
    return Object.prototype.toString.call(obj);
  },
  // 自定义的确认弹框
  customConfirm(
    text,
    title,
    { type, success, fail, confirmText, cancelText, ajax }
  ) {
    MessageBox.confirm(text || "确认弹框", title || "提示", {
      type: type || "warning",
      confirmButtonText: confirmText || "确认",
      cancelButtonText: cancelText || "取消",
      beforeClose: (action, ctx, done) => {
        if (action !== "confirm") {
          done();
          return;
        }
        ctx.confirmButtonLoading = true;
        ajax?.()
          .then((res) => {
            success?.(res);
            done();
            ctx.confirmButtonLoading = false;
          })
          .catch((err) => {
            done();
            fail?.(err);
            ctx.confirmButtonLoading = false;
          });
      },
    });
  },
  //根据文件名称获取文件类型
  getFileType(fileName) {
    let suffix = ""; // 后缀获取
    let result = ""; // 获取类型结果
    if (fileName) {
      const flieArr = fileName.split("."); // 根据.分割数组
      suffix = flieArr[flieArr.length - 1]; // 取最后一个
    }
    if (!suffix) return "other"; // fileName无后缀返回false
    suffix = suffix.toLocaleLowerCase(); // 将后缀所有字母改为小写方便操作
    // 匹配图片
    const imgList = ["png", "jpg", "jpeg", "bmp", "gif"]; // 图片格式
    result = imgList.find((item) => item === suffix);
    if (result) return "image";
    // 匹配txt
    const txtList = ["txt"];
    result = txtList.find((item) => item === suffix);
    if (result) return "txt";
    // 匹配excel
    const excelList = ["xls", "xlsx"];
    result = excelList.find((item) => item === suffix);
    if (result) return "excel";
    // 匹配word
    const wordList = ["doc", "docx"];
    result = wordList.find((item) => item === suffix);
    if (result) return "word";
    // 匹配pdf
    const pdfList = ["pdf"];
    result = pdfList.find((item) => item === suffix);
    if (result) return "pdf";
    // 匹配ppt
    const pptList = ["ppt", "pptx"];
    result = pptList.find((item) => item === suffix);
    if (result) return "ppt";
    // 匹配zip
    const zipList = ["rar", "zip", "7z"];
    result = zipList.find((item) => item === suffix);
    if (result) return "zip";
    // 匹配视频
    const videoList = [
      "mp4",
      "m2v",
      "mkv",
      "rmvb",
      "wmv",
      "avi",
      "flv",
      "mov",
      "m4v",
    ];
    result = videoList.find((item) => item === suffix);
    if (result) return "video";
    // 匹配音频
    const radioList = ["mp3", "wav", "wmv"];
    result = radioList.find((item) => item === suffix);
    if (result) return "radio";
    // 其他文件类型
    return "other";
  },
  getUrlParams(url) {
    const params = new URLSearchParams(url.split("?")[1]);
    const result = {};
    params.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  },
  /**
   * 获取中文
   * @param num
   * @returns {*}
   */
  SectionToChinese: function (section) {
    var ori = section;
    var strIns = "";
    var chnStr = "";
    var unitPos = 0;
    var zero = true;
    while (section > 0) {
      var v = section % 10;
      if (v === 0) {
        if (!zero) {
          zero = true;
          chnStr = chnNumChar[v] + chnStr;
        }
      } else {
        zero = false;
        strIns = chnNumChar[v];
        strIns += chnUnitChar[unitPos];
        chnStr = strIns + chnStr;
      }
      unitPos++;
      section = Math.floor(section / 10);
    }
    if (ori < 20) {
      chnStr = chnStr.replace("一十", "十");
    }
    return chnStr;
  },
  /**
   * 数字转中文
   * @param num
   * @returns {*}
   */
  numberToChanie: function (num) {
    var unitPos = 0;
    var strIns = "",
      chnStr = "";
    var needZero = false;

    if (num === 0) {
      return chnNumChar[0];
    }

    while (num > 0) {
      var section = num % 10000;
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr;
      }
      strIns = this.SectionToChinese(section);
      strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
      chnStr = strIns + chnStr;
      needZero = section < 1000 && section > 0;
      num = Math.floor(num / 10000);
      unitPos++;
    }
    return chnStr;
  },
  // 获取视频时长转换00:00:00
  secondsFormat(time) {
    let curtime = time;
    let h = parseInt(curtime / 3600);
    let m = parseInt((curtime % 3600) / 60);
    let s = parseInt(curtime % 60);
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    if (h == 0) {
      return m + ":" + s;
    } else {
      h = h < 10 ? "0" + h : h;
      return h + ":" + m + ":" + s;
    }
  },
};
const city = {
  11: "北京",
  12: "天津",
  13: "河北",
  14: "山西",
  15: "内蒙古",
  21: "辽宁",
  22: "吉林",
  23: "黑龙江 ",
  31: "上海",
  32: "江苏",
  33: "浙江",
  34: "安徽",
  35: "福建",
  36: "江西",
  37: "山东",
  41: "河南",
  42: "湖北 ",
  43: "湖南",
  44: "广东",
  45: "广西",
  46: "海南",
  50: "重庆",
  51: "四川",
  52: "贵州",
  53: "云南",
  54: "西藏 ",
  61: "陕西",
  62: "甘肃",
  63: "青海",
  64: "宁夏",
  65: "新疆",
  71: "台湾",
  81: "香港",
  82: "澳门",
  91: "国外 ",
};
// 身份证格式验证
const idNumber = (rule, value, callback) => {
  if (value) {
    if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
      callback(new Error("身份证号格式错误"));
    } else if (!city[value.substr(0, 2)]) {
      callback(new Error("身份证地址编码错误"));
    } else if (value.length == 18) {
      // 18位身份证需要验证最后一位校验位
      value = value.split("");
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验位
      let parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++) {
        ai = value[i];
        wi = factor[i];
        sum += ai * wi;
      }
      let last = parity[sum % 11];
      if (last != value[17]) {
        callback(new Error("身份证校验位错误"));
      } else {
        callback();
      }
    } else {
      callback();
    }
  } else {
    callback();
  }
};

const rules = {
  rule_idNumber: {
    //身份证验证
    validator: idNumber,
    trigger: "blur",
  },
};
// 获取guid
const getGuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};


const getFileSize = (size) => {
  let data = "";
  const _size = Number.parseFloat(size);
  if (_size < 1 * 1024) {
    //如果小于0.1KB转化成B
    data = _size.toFixed(2) + "B";
  } else if (_size < 1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (_size / 1024).toFixed(2) + "KB";
  } else if (_size < 1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (_size / (1024 * 1024)).toFixed(2) + "MB";
  } else {
    //其他转化成GB
    data = (_size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }
  const size_str = data + "";
  const len = size_str.indexOf(".");
  const dec = size_str.substr(len + 1, 2);
  if (dec == "00") {
    //当小数点后为00时 去掉小数部分
    return size_str.substring(0, len) + size_str.substr(len + 3, 2);
  }
  return size_str;
};

export { utils, rules, getGuid,getFileSize };
